import { Fragment, useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, CardTitle, Col, FormGroup, Input, Label, Row } from "reactstrap";
import Datetime from "react-datetime";
import BaseService from "../../../../../services/baseService";
import { actions as actionsSite } from "../../../../../redux/actions/site";
import SelectUf from "../../../../../components/Select/SelectUf/index";
import SelectTipoPessoa from "../../../../../components/Select/SelectTipoPessoa";
import { options as optionsUf } from "../../../../../components/Select/SelectUf/options";
import { options as optionsTipoPessoa } from "../../../../../components/Select/SelectTipoPessoa/options";
import Error from "../../../../../components/messagesModal/error";
import Success from "../../../../../components/messagesModal/success";
import RetryQuery from "../../../../../components/messagesModal/retryQuery";
import ErrorZeroBalance from "../../../../../components/messagesModal/errorZeroBalance";
import { currencyToFloat } from "../../../../../utils/converts";

const baseService = new BaseService("consulta");

const Step3 = ({ query, values, setCurrentStep }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [veiculoUfValue, setVeiculoUfValue] = useState();
  const [veiculoHodometroDataValue, setVeiculoHodometroDataValue] = useState();
  const [tipoPessoaProprietarioValue, setTipoPessoaProprietarioValue] = useState();
  const [ufImovelCompradorValue, setUfImovelCompradorValue] = useState();
  const [tipoPessoaCompradorValue, setTipoPessoaCompradorValue] = useState();

  const renderInputDatePicker = (props, openCalendar) => {
    return (
      <div className="form-control datePicker d-flex justify-content-between align-items-center">
        <input {...props} name="scheduleTo" className="" readOnly style={{border:'none'}}/>
        <i className="fa-solid fa-calendar-days" />
      </div>
    );
  };

  const handleSetVeiculoUfValue = (value) => {
    const _ufEmissaoValue = optionsUf.find(uf => uf.value === value);
    setVeiculoUfValue(_ufEmissaoValue);
  }

  const handleSetTipoPessoaProprietarioValue = (value) => {
    const _tipoPessoaProprietarioValue = optionsTipoPessoa.find(tipoPessoa => tipoPessoa.value === value);
    setTipoPessoaProprietarioValue(_tipoPessoaProprietarioValue);
  }

  const handleSetUfImovelCompradorValue = (value) => {
    const _ufImovelCompradorValue = optionsUf.find(uf => uf.value === value);
    setUfImovelCompradorValue(_ufImovelCompradorValue);
  }

  const handleSetTipoPessoaCompradorValue = (value) => {
    const _tipoPessoaCompradorValue = optionsTipoPessoa.find(tipoPessoa => tipoPessoa.value === value);
    setTipoPessoaCompradorValue(_tipoPessoaCompradorValue);
  }

  useEffect(() => {
    if (values.veiculo_uf) {
      handleSetVeiculoUfValue(values.veiculo_uf);
    }

    if (values.veiculo_hodometro_data) {
      const veiculo_hodometro_data = typeof values.veiculo_hodometro_data === 'object' ? values.veiculo_hodometro_data.format("DD/MM/YYYY") : values.veiculo_hodometro_data;
      setVeiculoHodometroDataValue(veiculo_hodometro_data);
    }

    if (values.proprietario_pessoa) {
      handleSetTipoPessoaProprietarioValue(values.proprietario_pessoa);
    }

    if (values.comprador_uf) {
      handleSetUfImovelCompradorValue(values.comprador_uf);
    }

    if (values.comprador_pessoa) {
      handleSetTipoPessoaCompradorValue(values.comprador_pessoa);
    }
  }, [values])

  const goOrderPayment = useCallback(() => {
    dispatch(actionsSite.closeModal());
    history.push("/financeiro/ordens-de-pagamento");
  },[dispatch, history]);

  const showMessageModal = useCallback(({ error, msg, icon=null, loadingCar=false }) => {
    const CompError = msg.includes('Sem saldo para realizar') ? ErrorZeroBalance : Error ;
    const configModal = {
      component: error ? <CompError msg={msg} goOrderPayment={goOrderPayment} /> : <Success msg={msg} icon={icon} loadingCar={loadingCar} />,
      title: error ? `Erro` : `Sucesso`,
    };
    dispatch(actionsSite.setModal(configModal));
  },[dispatch, goOrderPayment]);

  const execute = async () => {
    try {
      const keyValues = Object.keys(values);

      const payload = {
        veiculo:{},
        proprietario: {},
        comprador:{}
      }

      for (const key of keyValues) {
        if (key.indexOf('veiculo_') !== -1) {
          payload.veiculo[key.replace('veiculo_','')] = values[key];
        }

        if (key.indexOf('proprietario_') !== -1) {
          payload.proprietario[key.replace('proprietario_','')] = values[key];
        }

        if (key.indexOf('comprador_') !== -1) {
          payload.comprador[key.replace('comprador_','')] = values[key];
        }
      }

      payload.veiculo.valor_venda = currencyToFloat(payload.veiculo.valor_venda)
      payload.veiculo.hodometro_data = payload.veiculo.hodometro_data.format("YYYY-MM-DD");
      payload.veiculo.hodometro = payload.veiculo.hodometro.replace(/\D/g,'');
      payload.proprietario.documento = payload.proprietario.documento.replace(/\D/g,'');
      payload.comprador.documento = payload.comprador.documento.replace(/\D/g,'');

      showMessageModal({ error: false, msg: "Enviando ATPVe, por favor aguarde", loadingCar: true });

      baseService._postConsulta(`${baseService.route}/${query.code}`, payload)
        .then((res) => {
          if (res.success === false && res.duplicatedQuery) {
            const configModal = {
              component: <RetryQuery logquery={res.logqueryOrigin} msg={res.msg} execute={execute} values={payload}/>,
              title: 'Suspeita de consulta em duplicidade',
            };
            dispatch(actionsSite.setModal(configModal));
            return;
          }

          showMessageModal({ error: !res.success, msg: res.msg });
          if(res.success){
            history.push("/historico/" + res.logQuery);
          }
        })
        .catch((error) => {
          if (error.response) {
            showMessageModal({ error: true, msg: error.response.data.msg })
          }
        });
    } catch (e) {
      console.log(e.toString());
    }
  };

  return (
    <Fragment>
      <Card className="border-custom">
      <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados do Veículo</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
            <FormGroup>
                <Label htmlFor="placa">Placa</Label>
                <Input type="text" className={"form-control"} value={values.veiculo_placa} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="renavam">Renavam</Label>
                <Input type="text" className={"form-control"} value={values.veiculo_renavam} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="chassi">Chassi</Label>
                <Input type="text" className={"form-control"} value={values.veiculo_chassi} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="veiculo_crv">Número Crv</Label>
                <Input type="text" className={"form-control"} value={values.veiculo_crv} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="veiculo_uf">UF</Label>
                <SelectUf value={veiculoUfValue} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="veiculo_hodometro">Hodômetro (Quilometragem em KM)</Label>
                <Input type="text" className={"form-control"} value={values.veiculo_hodometro} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="veiculo_hodometro_data">Data Hodômetro</Label>
                <Datetime
                  locale="pt-br"
                  value={veiculoHodometroDataValue}
                  timeFormat={false}
                  closeOnSelect={true}
                  closeOnClickOutside={true}
                  renderInput={renderInputDatePicker}
                  inputProps={{ disabled: true }}
                />
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
              <Label htmlFor="veiculo_valor_venda">Valor Venda R$</Label>
                <Input type="text" className={"form-control"} value={values.veiculo_valor_venda} disabled={true} />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados do Proprietário Atual</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="proprietario_pessoa">Tipo Pessoa</Label>
                <SelectTipoPessoa value={tipoPessoaProprietarioValue} disabled={true}/>
              </FormGroup>
            </Col>
            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="proprietario_documento">CPF ou CNPJ</Label>
                <Input type="text" className={"form-control"} value={values.proprietario_documento} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="proprietario_rg">RG</Label>
                <Input type="text" className={"form-control"} value={values.proprietario_rg} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="proprietario_email">Email</Label>
                <Input type="text" className={"form-control"} value={values.proprietario_email} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="proprietario_telefone">Telefone</Label>
                <Input type="text" className={"form-control"} value={values.proprietario_telefone} disabled={true}/>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados do Comprador</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
					<Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_pessoa">Tipo Pessoa</Label>
                <SelectTipoPessoa value={tipoPessoaCompradorValue} disabled={true}/>
              </FormGroup>
            </Col>
            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_documento">CPF ou CNPJ</Label>
                <Input className={"form-control"} value={values.comprador_documento} disabled={true}/>
              </FormGroup>
            </Col>

						<Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_nome">Nome</Label>
                <Input type="text" className={"form-control"} value={values.comprador_nome} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_rg">RG</Label>
                <Input type="text" className={"form-control"} value={values.comprador_rg} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_email">Email</Label>
                <Input type="text" className={"form-control"} value={values.comprador_email} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_telefone">Telefone</Label>
                <Input type="text" className={"form-control"} value={values.comprador_telefone} disabled={true}/>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
				<CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Endereço</CardTitle>
        </CardHeader>

        <CardBody>
					<Row>
					<Col sm="6" md="4">
          <FormGroup>
                <Label htmlFor="comprador_cep">CEP</Label>
                <Input type="text" className={"form-control"} value={values.comprador_cep} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
            <FormGroup>
                <Label htmlFor="comprador_uf">UF</Label>
                <SelectUf value={ufImovelCompradorValue} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_bairro">Bairro</Label>
                <Input type="text" className={"form-control"} value={values.comprador_bairro} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_logradouro">Logradouro</Label>
                <Input type="text" className={"form-control"} value={values.comprador_logradouro} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_numero">Número</Label>
                <Input type="text" className={"form-control"} value={values.comprador_numero} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="comprador_complemento">Complemento</Label>
                <Input type="text" className={"form-control"} value={values.comprador_complemento} disabled={true}/>
              </FormGroup>
            </Col>
					</Row>
				</CardBody>
      </Card>
      <Card className="border-custom">
        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Enviar Comunicado</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <h2>Você tem certeza que os dados preenchidos estão corretos?</h2>
              <h2>Se SIM, clique em "Enviar" para confirmar o envio do ATPVe.</h2>
              <h2>Se NÃO, clique em "Anterior" e revise os dados.</h2>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div className="text-center">
        <Button className="mr-1" color="primary" onClick={() => setCurrentStep(1)}>Anterior</Button>
        <Button className="mr-1" color="success" onClick={execute}>Enviar</Button>
      </div>
    </Fragment>
  );
};

export default Step3;